import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem, MessageService } from 'primeng/api';
import { FsvVendorWiseModel } from 'src/app/models/department-reports.model';
import { DashboardService } from 'src/app/services/dashboard.service';
import { ReportsService } from 'src/app/services/reports.service';
import { first } from 'rxjs';
import saveAs from 'file-saver';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import {shareReplay} from 'rxjs/operators';
import { BaseService } from 'src/app/services/common/base.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
@Component({
  selector: 'app-fsv-vendor-wise-report',
  templateUrl: './fsv-vendor-wise-report.component.html',
  styleUrls: ['./fsv-vendor-wise-report.component.scss']
})
export class FsvVendorWiseReportComponent implements OnInit {

  vendorWise: any[];
  fsvDeposited:number;
  fsvPaid:number;
  onTime:number;
  pendingByWeek:number;
  pendingMoreThanWeek:number;
  amountPaid:number;
  miArea:number;
  grandFsvDeposited:number;
  grandFsvPaid:number;
  grandOnTime:number;
  grandPendingByWeek:number;
  grandPendingMoreThanWeek:number;
  grandAmountPaid:number;
  grandMiArea:number;
  arrayIndex:number;
  tempVendorWise: any[];
  appVerificationItems: MenuItem[];
  appVerificationModel: FsvVendorWiseModel[];
  filteredDataForExport: any = [];
  cols: ({ field: string; header: string; customExportHeader: string; } | { field: string; header: string; customExportHeader?: undefined; })[];
  exportColumns: { title: string; dataKey: string; }[];
  public filteredData: any = [];
  public totalSelectedApp: any = 0;
  public totalSubToFarmer: any = 0;
  public totalSubToVendor: any = 0;
  public totalFarmerRefund: any = 0;
  
  public userID: any;
  displayMaximizable_pendingApp:boolean;
  drilldownDetails:any;
  pendingType:any;
  value:any
  vendorName:any
  public subscriptions: any = [];
  public loading: boolean = false;
  routePath:any;
  subjectSub:any;
  selectedYear:any;
  constructor(private reportsService:ReportsService
     ,private messageService:MessageService
     ,private dashboard: DashboardService
     ,private router: Router
     ,private activityRecordService: ActivityRecordService
     ,private loader: AppLoaderService
     ,private service: BaseService
     ,private cryptoJsService: CryptoJsService) { }

  ngOnInit(): void {
    if(sessionStorage.getItem('financialYear')){
      this.service.changeFinancialYear(sessionStorage.getItem('financialYear'))    
    }
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userID = JSON.parse(payload)?.sub;

    this.subjectSub= this.service.getSelectedYear().pipe(shareReplay()).subscribe(
      (res) => {
          let router=this.router.url
    // this.routePath=router.split('/')
    this.subscriptions.forEach(sub => sub.unsubscribe());
        this.selectedYear=res
        
        this.loadData(this.selectedYear)
      }
          
  );
    this.appVerificationItems = [
      {
        label: 'Download excel', icon: 'pi pi-fw pi-download', command: () => {
          this.exportExcel(this.appVerificationModel, "Vendor_wise_report");
        }
      },
      {
        label: 'Download Pdf', icon: 'pi pi-fw pi-download', command: () => {
          this.downloadSheetAsPdf(this.appVerificationModel, "Vendor_wise_report");
        }
      },
    ];
  }
  ngOnDestroy(){
    this.subscriptions.forEach(sub => sub.unsubscribe());
    if(this.subjectSub){
      this.subjectSub.unsubscribe()
    }
  }

  loadData(selectedYear:any){
    // this.loader.start();
    this.loading = true;
    let sub=this.reportsService.getFSV_VendorWise_Report(selectedYear)
        .pipe(first())
        .subscribe({
          next: (data) => {
            this.activityRecordService.activityRecord(this.userID, 'FSV Report (Vendor Wise)', '', new Date(), 'Success');
            // this.loader.close();
            this.loading = false;
            // console.log("dataaa", data)
            if (data?.length > 0) {
              this.vendorWise = data;
              this.appVerificationModel = data;
              this.tempVendorWise=data;
              this.arrayIndex=0;
              this.calculateGrandTotal()
             
            }
            else{
              this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Data Not Available' });
              this.vendorWise = [];
              this.appVerificationModel =[] ;
              this.tempVendorWise=[];
              this.arrayIndex=0;
              this.calculateGrandTotal()

            }
          },
          error: (err) => {
            // this.loader.close();
            this.loading = false;
            this.activityRecordService.activityRecord(this.userID, 'FSV Report (Vendor Wise)', '', new Date(), err);

            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });

          }
        });
        this.subscriptions.push(sub);
  }

  exportExcel(modelData, filename) {
    
    if (!modelData) {
      modelData = [];
    }
    import("xlsx").then(xlsx => {
      let dataToSave = modelData.map((d: any) => {
        // console.log(d)
        return {
          "Vendor Name" : d.VendorName,
          "FSV Deposited" : d.FSVDeposited,
          "FSV Paid": d.FSVPaid,
          "On Time": d.PendingEarly,
          "Pending a Week": d.Pending_1Week,
          "Pending More than a Weeks": d.Pending_Morethan_1Weeks,
          "Amount Paid": d.AmountPaid,
          "MI Area": d.MIArea,
        }
      })
      
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      saveAs(
        data,
        fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }
  downloadSheetAsPdf(modelData, filename) {
    this.cols = [
      {field: 'VendorName', header: 'Vendor Name'},
      {field: 'FSVDeposited', header: 'FSV Deposited'},
      { field: 'FSVPaid', header: 'FSV Paid' },
      { field: 'PendingEarly', header: 'On Time' },
      {field: 'Pending_1Week', header: 'Pending a Week'},
      {field: 'Pending_Morethan_1Weeks', header: 'Pending More than a Week'},
      {field: 'AmountPaid', header: 'AmountPaid'},
      {field: 'MIArea', header: 'MI Area'},
     
    ];

    this.exportColumns = this.cols.map(col => ({ title: col.header, dataKey: col.field }));

    import("jspdf").then(jsPDF => {
      import("jspdf-autotable").then(x => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(this.exportColumns, modelData);
        doc.save(`${filename}.pdf`);
      })
    })
  }
  tableDataFunction(event: any) {
    this.tempVendorWise=event.filteredValue
    //console.log(event);
    this.arrayIndex=0;
    // console.log(this.vendorWise);
    this.calculateTotalApp() ;
  }
  onPage(event:any) {
        this.arrayIndex=event.first;
        this.calculateTotalApp()
        //console.log(event);
      }
calculateTotalApp() {
        this.fsvDeposited=0;
        this.fsvPaid=0;
        this.onTime=0;
        this.pendingByWeek=0;
        this.pendingMoreThanWeek=0;
        this.amountPaid=0;
        this.miArea=0;
        for(let i=this.arrayIndex ;this.tempVendorWise.length>10?i<this.arrayIndex+10:i<this.tempVendorWise.length;i++) {
          //console.log( this.totalApp,"totalAPPPPPPPPP")
          this.fsvDeposited +=this.tempVendorWise[i].FSVDeposited;
          this.fsvPaid +=this.tempVendorWise[i].FSVPaid;
          this.onTime += this.tempVendorWise[i].PendingEarly;
          this.pendingByWeek += this.tempVendorWise[i].Pending_1Week;
          this.pendingMoreThanWeek += this.tempVendorWise[i].Pending_Morethan_1Weeks;
          this.amountPaid += this.tempVendorWise[i].AmountPaid;
          this.miArea +=this.tempVendorWise[i].MIArea;

        }      
    }
    calculateGrandTotal(){
      this.grandFsvDeposited=0;
      this.grandFsvPaid=0;
      this.grandOnTime=0;
      this.grandPendingByWeek=0;
      this.grandPendingMoreThanWeek=0;
      this.grandAmountPaid=0;
      this.grandMiArea=0;
      for(let vendorData of this.tempVendorWise) {
        this.grandFsvDeposited += vendorData.FSVDeposited;
        this.grandFsvPaid += vendorData.FSVPaid;
        this.grandOnTime += vendorData.PendingEarly;
        this.grandPendingByWeek += vendorData.Pending_1Week;
        this.grandPendingMoreThanWeek += vendorData.Pending_Morethan_1Weeks;
        this.grandAmountPaid += vendorData.AmountPaid;
        this.grandMiArea += vendorData.MIArea;
    }
    }
    showMaximizableDialog_pending(value:any,duration:any,vendorName:any) {
      
      if(duration=='early'){
        this.pendingType='On Time'
      }
      if(duration=='1Week'){
        this.pendingType='Pending by Week'
      }
      if(duration=='morethan_1Week'){
        this.pendingType='Pending more than one Week' 
      }
      this.value=value;
      this.vendorName=vendorName
      this.drilldownDetails={
        actionType:"FSV",
        
        filterType:"Vendor",
        value:this.value,
        duration:duration,
        MIType:"",
        Block:""
      }
      
      this.displayMaximizable_pendingApp = true;
      // console.log(this.value,"value")
      // console.log(this.drilldownDetails,"this.drilldownDetails")
    
    }


}
